












































































































































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {SavePatPna} from "@/api/hd"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() data: any
	@Prop() value: boolean
	model: any = {
		patientId: this.data.patient.id,
		recordDate: new Date(),//记录时间
		nextRecordDate: new Date(),//下次时间
		changeWeightScore: 0,//体重改变
		metatrophyScore: 0,//饮食改变
		gastrointestinalSymptomsScore: 0,//肠胃症状
		mobilityScore: 0,//活动能力
		complicationScore: 0,//并发症
		subcutaneousFatScore: 0,//脂肪储备/皮下脂肪
		muscleWastingScore: 0,//肌肉消耗
	}

	get sga() {
		return this.model.changeWeightScore + this.model.metatrophyScore
			+ this.model.gastrointestinalSymptomsScore + this.model.mobilityScore
			+ this.model.complicationScore + this.model.subcutaneousFatScore + this.model.muscleWastingScore
	}

	created() {
		if (this.data.mode === 'add') {
			//下次时间默认下个月
			this.model.nextRecordDate.setTime(this.model.recordDate.getTime() + 3600 * 1000 * 24 * 30)
		} else {
			this.model = Object.assign({},this.data.item)
		}


	}

	async save() {
		if (!this.model.changeWeightScore ||
			!this.model.metatrophyScore ||
			!this.model.gastrointestinalSymptomsScore ||
			!this.model.mobilityScore ||
			!this.model.complicationScore ||
			!this.model.subcutaneousFatScore ||
			!this.model.muscleWastingScore) {
			this.$Message.error('存在评估没选择！')
		} else {
			this.model.sga = this.sga
			let res = await SavePatPna(this.model)
			if (res.status === 1) {
				this.$emit('save-success')
			}
		}
	}

	get dialogTitle() {
		return `${this.data.mode === 'add' ? '新增' : '编辑'}营养评估`
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	cancel() {
		this.$emit('input', false);
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/addOrEdit.vue